function f(t, e, u) {
  if (e < 1)
    return [];
  if (e === 1 && u === void 0)
    return t;
  for (var r = [], n = 0; n < t.length; n += e)
    r.push(t[n]);
  return r;
}
export {
  f as getEveryNthWithCondition
};
